import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { Configuration, DepositsSearchParamsDTO, DepositTransactionsDto, PmsApi, TransactionItemSummaryV2Dto } from "@inosio/payments-sdk";
import { selectCurrentUser } from "../../../shared/sagas/auth/authSlice";
import {
    getDepositsHistoryDetails,
    getDepositTransactions,
    setDepositsError,
    setDepositsHistoryDetails,
    setDepositsHistoryDetailsExport,
    setDepositTransactions,
} from "./pmDepositsSlice";
import {IpaUserExtended} from "../../../shared/sagas/auth/authSlice";

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

enum reportExportType {
    PDF = 'PDF',
    CSV = 'CSV'
};

export function requestGetDepositsHistory(
    access_token: string,
    pmUUID: string,
    depositSearchParams: DepositsSearchParamsDTO,
    exportAs?: reportExportType,
    fileName?: string
) {
    apiConfig.accessToken = access_token;
    const ipaPmAPI = new PmsApi(apiConfig);
    const responseType = exportAs === undefined ? 'json' : 'arraybuffer'
    const contentDisposition = (exportAs === undefined) ? '' : (exportAs === 'CSV') ? 'text/csv' : 'application/pdf';
    const headerParams = {
        'Content-Disposition': contentDisposition,
    }

    return ipaPmAPI.searchDepositsDebitsByPM(pmUUID, depositSearchParams, exportAs, fileName, { responseType, headers: headerParams });
}

export function requestGetDepositTransactions(
    access_token: string,
    pmUUID: string,
    depositUUID: string
) {
    apiConfig.accessToken = access_token;
    const ipaPmAPI = new PmsApi(apiConfig);

    return ipaPmAPI.getTransactionsByDepositId(pmUUID, depositUUID);
}

export function* handleGetDepositsHistory(action: any) {
    try {
        const currentUser:IpaUserExtended= yield select(selectCurrentUser);
        const response: AxiosResponse<TransactionItemSummaryV2Dto> = yield call(
            requestGetDepositsHistory,
            currentUser.accessToken,
            currentUser.currentProfile.uuid,
            action.payload,
            action.payload.exportAs,
            action.payload.fileName
        )

        if (response.headers['content-type'].startsWith('application/json')) {
            const { data } = response;
            yield put(setDepositsHistoryDetails(data));
        }
        else {
            const fileType = action.payload.exportAs === 'PDF' ? 'application/pdf' : 'text/csv';
            const fileExtension = action.payload.exportAs === 'PDF' ? 'pdf' : 'csv'


            // @ts-ignore
            const url = window.URL.createObjectURL(new Blob([response.data], { type: fileType }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${action.payload.fileName}.${fileExtension}`); //or any other extension
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);
        }
        yield put(setDepositsHistoryDetailsExport());
    } catch (error: any) {
        yield put(setDepositsError({
            message: error?.response?.data?.message,
            statusCode: error?.response?.data?.statusCode
        }));
    }
}

export function* handleGetDepositTransactions(action: {
    type: typeof getDepositTransactions,
    payload: any
}) {
    try {
        const currentUser:IpaUserExtended= yield select(selectCurrentUser);
        const response: AxiosResponse<DepositTransactionsDto> = yield call(
            requestGetDepositTransactions,
            currentUser.accessToken,
            currentUser.currentProfile.uuid,
            action.payload.depositUuid
        );
        const { data } = response;
        yield put(setDepositTransactions(data));
    } catch (error: any) {
        yield put(setDepositsError({ message: error?.response?.data?.message }));
    }
}

export function* pmDepositsSaga() {
    yield takeLatest(
        getDepositsHistoryDetails.type,
        handleGetDepositsHistory
    );
    yield takeLatest(
        getDepositTransactions.type,
        handleGetDepositTransactions
    );
}
